interface Props {
  spiegazione: string;
  isCorrect: boolean;
}

export function ExplanationBox({ spiegazione, isCorrect }: Props) {
  const icon = isCorrect ? "✅" : "💡";
  const title = isCorrect ? "Corretto" : "Rivediamo insieme";
  const borderColor = isCorrect ? "border-green" : "border-accent";

  return (
    <div className={`mt-4 bg-bg border-l-4 ${borderColor} rounded-r-xl p-4`}>
      <div className="flex items-start gap-3">
        <span className="text-2xl flex-none">{icon}</span>
        <div className="flex-1">
          <div className="font-mono uppercase text-xs tracking-wider text-secondary mb-2">
            {title}
          </div>
          <p className="text-primary leading-relaxed">{spiegazione}</p>
        </div>
      </div>
    </div>
  );
}
